module.exports = __webpack_public_path__ + "static/img/cardpay-logo-white.776061f7.svg";